<div class="center" style="position: relative">
  <ngx-file-drop (onFileDrop)="dropped($event)" (onFileLeave)="fileLeave($event)" (onFileOver)="fileOver($event)"
    contentClassName="file-drop-zone"
    dropZoneClassName="file-drop-zone" dropZoneLabel="Solte o arquivo aqui">
    <ng-template let-openFileSelector="openFileSelector" ngx-file-drop-content-tmp>
      <button (click)="openFileSelector()" [disabled]="loading" color="accent" mat-raised-button type="button">
        @if (iconButton) {
          <mat-icon matTooltip="Icone">{{ iconButton }}</mat-icon>
        }
        <span [innerHTML]="titleButton"></span>
      </button>
      @if (showRemoveButton) {
        <button (click)="removeFile();$event.stopPropagation();" color="primary"
          mat-icon-button
          type="button">
          <mat-icon matTooltip="Remover arquivo">close</mat-icon>
        </button>
      }
    </ng-template>
  </ngx-file-drop>
</div>
